<div class="news-detail-page">
  <div class="news-detail-header">
    <button class="back-btn" (click)="goBack()">← 返回新闻中心</button>
  </div>
  <div class="news-detail-content" [innerHTML]="newsContent"></div>
  <div class="news-detail-loading" *ngIf="loading">
    <p>加载中...</p>
  </div>
</div>
